// extracted by mini-css-extract-plugin
export default {"cls1":"Attachment-cls1___2d41100a3b4342bc67d","cls2":"Attachment-cls2__c0a3bde2e4c19bdb2478 Attachment-cls1___2d41100a3b4342bc67d"};